// Styles
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
// Vuetify
import { createVuetify } from 'vuetify'
export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  {
    ssr: true,
    components,
    directives,
    icons: {
      defaultSet: 'mdi', // 使用 MDI 图标集
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      themes: {
        light: {
          primary: '#6200ea', // 主色调
          secondary: '#03dac6', // 辅助色调
          accent: '#ff4081', // 强调色
          error: '#f44336',
          warning: '#ff9800',
          info: '#2196f3',
          success: '#4caf50',
        },
      },
      dark: {
        primary: '#BB86FC',
        secondary: '#03DAC6',
        accent: '#03DAC6',
        error: '#CF6679',
        warning: '#FBC02D',
        info: '#2196F3',
        success: '#4CAF50',
      },
    },
  }
)
